import axios from 'axios';
import { isServer, settings } from '../settings';
import { getAccessToken } from 'services/auth';

const postService = (accessToken) => {
  return axios.create({
    baseURL: (isServer && process.env.API_SERVICE_URL_POST) || settings.API_SERVICE_URL_POST,
    timeout: isServer ? 2000 : 10000,
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
  });
};

// post
export const getPost = async ({ postId }) => {
  return postService().get(`/post/${postId}`);
};

// playlist
export const createPlaylist = async ({ title, description, isPrivate }) => {
  const body = {
    title,
    description,
    private: isPrivate,
  };
  return postService(await getAccessToken()).post('/playlist', body);
};

export const getPlaylist = async ({ userId, playlistId }) => {
  return postService(await getAccessToken()).get(`/playlist/${userId}/${playlistId}`);
};

export const deletePlaylist = async ({ playlistId }) => {
  return postService(await getAccessToken()).delete(`/playlist/${playlistId}`);
};

export const editPlaylistData = async ({ playlistId, title, description, isPrivate }) => {
  const body = {
    title,
    description,
    private: isPrivate,
  };
  return postService(await getAccessToken()).put(`/playlist/${playlistId}`, body);
};

export const getUsersPlaylists = async ({ userId }) => {
  return postService(await getAccessToken()).get(`/playlists/${userId}`);
};

export const getProfilePlayLists = async ({ username, accessToken }) => {
  return postService(accessToken).get(`/play-lists/${username}`);
};

export const playlistKudo = async ({ playlistId, direction }) => {
  const body = {
    playlist_id: playlistId,
    vote: direction === 'up' ? 1 : -1,
  };
  return postService(await getAccessToken()).post('/playlistkudo', body);
};

export const playlistAddItem = async ({ playlistId, itemId }) => {
  return postService(await getAccessToken()).post(`/playlist-item/${playlistId}/${itemId}`);
};

export const playlistDeleteItem = async ({ playlistId, itemPostition }) => {
  return postService(await getAccessToken()).delete(`/playlistd/${playlistId}/${itemPostition}`);
};

// favourite playlist
export const getFavouritePlaylist = async () => {
  return postService(await getAccessToken()).get('/favourite');
};

// follows playlists
export const getMyPlaylistFollows = async () => {
  return postService(await getAccessToken()).get('/playlistfollow');
};

export const followPlaylist = async ({ playlistId }) => {
  return postService(await getAccessToken()).post(`/playlistfollow/${playlistId}`);
};

export const unfollowPlaylist = async ({ playlistId }) => {
  return postService(await getAccessToken()).delete(`/playlistfollow/${playlistId}`);
};

export const alterPlaylistOrder = async ({ newPositionList, playlistId }) => {
  const body = {
    new_positions: newPositionList,
  };
  return postService(await getAccessToken()).put(
    `playlist-order-alter/${playlistId}`,
    JSON.stringify(body),
  );
};

export const getTagsStats = async () => {
  return postService(await getAccessToken()).get('/stats/post-data');
};
